// extracted by mini-css-extract-plugin
module.exports = {"completeMessage":"GiftCardForm_completeMessage__OaqQY"};